// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061428/js/" + chunkId + "." + {"44":"55308c92","225":"2e6009a1","481":"c097787c","486":"c59c3657","770":"442f3b35"}[chunkId] + ".0.2042198113163065.chunk.js";
};